import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { RSF } from '../rsf';
import { FormStatusEnum } from 'src/app/common/enumerations/enumerations';

@Component({
  selector: 'rsf-toolbar',
  templateUrl: './rsf-toolbar.component.html',
  styleUrls: ['./rsf-toolbar.component.scss']
})
export class RsfToolbarComponent {
  @Input() rsf?: RSF | null;
  @Input() moduleTitle?: string;
  @Input() showAmendmentToggle?: boolean;
  @Input() isViewingAmendment?: boolean;

  @Output() menuClicked = new EventEmitter();
  @Output() isViewingAmendmentChanged = new EventEmitter<boolean>();

  formStatusEnum = FormStatusEnum;
  toggleChanged(event: MatSlideToggleChange) {
    this.isViewingAmendmentChanged.emit(event.checked);
  }
}
